// As cores das séries do desembolso, compartilhadas pelo gráfico do topo (`AmpliCurveChart`) e
// pela pizza da cobertura (`CoverageDoughnut`): o que segue a origem (físico-financeiro ou
// previsto) tem a cor da linha da origem, e o que as regras movem tem a cor das barras do
// desembolso resultante. Mudar aqui muda os dois.
export const PHYSICAL_COLOR = "#BA52F2";
export const INITIAL_COLOR = "#F79009";
export const RESULTING_COLOR = "#2563EB";
export const UNDISTRIBUTED_COLOR = "#D0D5DD";
